var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.443 14.862a7.4 7.4 0 0 0 4.473-1.506L15.556 17 17 15.555l-3.64-3.645a7.335 7.335 0 0 0 1.505-4.479c0-4.092-3.335-7.43-7.422-7.43C3.335-.02 0 3.318 0 7.43c0 4.113 3.335 7.431 7.443 7.431zm0-12.846c2.968 0 5.388 2.422 5.388 5.395 0 2.972-2.42 5.395-5.388 5.395-2.97 0-5.41-2.402-5.41-5.375a5.41 5.41 0 0 1 5.41-5.415z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.7f68d3b36dcf2b90c91c95a2ac7fe63c.svg";
export { ForwardRef as ReactComponent };